



















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ImageUploadForm extends Vue {

  @Prop({ required: true })
  index: number

  @Prop({ required: true })
  onUpload: (file: File|null, index: number) => void

  onChange(event): void {
    const files = event.target.files || event.dataTransfer.files
    if (files.length <= 0) {
      return
    }

    const file = files[0]

    // file size limitation upto 8MB
    // tslint:disable-next-line: no-magic-numbers
    if (file.size > 8388608) {
      this.onUpload(null, this.index)

      return
    }

    this.onUpload(file, this.index)
  }
}
